var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#1C1CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9913 40.4636L39.9961 49.5349V15L54.9913 40.4636Z",
    fill: "white",
    fillOpacity: 0.76
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9956 15L25 40.4636L39.9956 49.5349V33.4881V15Z",
    fill: "white",
    fillOpacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0005 43.3739L40.0005 64.9933L39.9961 52.4404L55.0005 43.3739Z",
    fill: "white",
    fillOpacity: 0.76
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9956 64.9996V52.4404L25 43.3739L39.9956 64.9996Z",
    fill: "white",
    fillOpacity: 0.45
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9961 49.5349L54.9913 40.4636L39.9961 33.4881V49.5349Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40.4636L39.9956 49.5349V33.4881L25 40.4636Z",
    fill: "white",
    fillOpacity: 0.57
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.71f56b40287f3d3dabc44420f5d8c525.svg";
export { ForwardRef as ReactComponent };